import { useContextWrapper } from '../../../shared/hooks/useContext'
import { AuthContext } from '../context/auth'

export const useAuth = () => useContextWrapper(AuthContext)
